//! Retract Access (With Group) - under development
import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import _, { update } from "lodash";
import TimeStamp from "react-timestamp";
// React-bootstrap
import { Button, Modal } from "react-bootstrap";
// No Data Found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { fire, auth } from "../../firebase/index";
// import axios from "axios";
import "../../routes/app";
//? import chatbot
// import Chatbot from "../../views/Chatbot/Chatbot";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  SizePerPageDropDown,
} from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import { confirmAlert } from "react-confirm-alert";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import SwitchBtn from "./SwitchBtn";
import GroupSwitchBtn from "./GroupSwitchBtn";
import RetractLock from "../Tutorial/RetractLockGuide";
import Infolockbutton from "./infolockbutton";
import { deleteRetractableId } from "./RetractableHelper";
import { deleteRetractableGroupId } from "./RetractableHelper";
import MultiApprovalInfo from "./MultiApprovalInfo";
import individuallock from "assets/img/dashboardimages/lockimg.png";
import individuallocknopress from "assets/img/dashboardimages/individualonpressed.png";
import grouplockpiconpress from "assets/img/dashboardimages/total-number-lock-1.png";
import grouplockpic from "assets/img/dashboardimages/grouplock_Logo.png";

import { customLog } from "../../variables/Variables";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import "react-confirm-alert/src/react-confirm-alert.css";

import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    retractAccessTitle: "Retract Access",
    retractDescription: "Remove access from shared retractable locks",
    retractDescription2: "",
    shareToHeader: "Share To",
    nameHeader: "Lock Name",
    lockSerialHeader: "Lock Serial",
    infoHeader: "Info",
    startHeader: "Start",
    endHeader: "End",
    allowAccessHeader: "Allow Access",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    removeSelectedBtn: "Remove Selected",
    retractLockGuide: "Retract Lock",
    shareModeHeader: "Share Mode",
    normalGrantAccess: "Normal Grant Access",
    recurringGrantAccess: "Recurring Grant Access",
    recurringTimedGrantAccess: "Recurring Timed Grant Access",
    multiApproveAccess: "Multi Approve Access",
    multiApproveOneTimeAccess: "Multi Approve & One Time Access",
    oneTimeAccess: "One Time Access",
    individualTab: "Individual Lock",
    groupTab: " Lock Groups",
    searchPlaceholder: "Search",
    groupNameHeader: "Lock Group Name",
    groupNumberHeader: "Group Lock No.",
    viewHeader: "View Locks",
  },
  ja: {
    retractAccessTitle: "アクセス権限設定",
    retractDescription:
      "アクセス権限を完全に削除する場合は、該当のロックにチェックし、削除ボタンをクリックします。",
    retractDescription2:
      "アクセスを停止する場合は、「アクセス許可」を無効（グレー）にします。",
    shareToHeader: "メンバーEメール",
    nameHeader: "ロック名",
    lockSerialHeader: "ロックシリアル",
    infoHeader: "詳細",
    startHeader: "アクセス開始日",
    endHeader: "アクセス終了日",
    allowAccessHeader: "アクセス許可",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    removeSelectedBtn: "削除",
    retractLockGuide: "ロックを削除する",
    shareModeHeader: "共有モード",
    normalGrantAccess: "アクセス譲渡",
    recurringGrantAccess: "曜日設定（アクセススケジュール）",
    recurringTimedGrantAccess: "曜日・時間設定",
    multiApproveAccess: "承認者追加",
    multiApproveOneTimeAccess: "承認者追加＆ワンタイム解錠",
    oneTimeAccess: "ワンタイム解錠",
    individualTab: "個別ロック",
    groupTab: " ロックグループ",
    searchPlaceholder: "検索",
    groupNameHeader: "ロックグループ名",
    groupNumberHeader: "グループロック番号",
    viewHeader: "ロックを見る",
  },
  es: {
    retractAccessTitle: "Retirar Acceso",
    retractDescription: "Eliminar acceso de candados compartidas y retráctiles",
    retractDescription2: "",
    shareToHeader: "Compartir A",
    nameHeader: "Nombre de la Candado",
    lockSerialHeader: "Número de Serie de la Candado",
    infoHeader: "Información",
    startHeader: "Inicio",
    endHeader: "Fin",
    allowAccessHeader: "Permitir Acceso",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    removeSelectedBtn: "Eliminar Seleccion",
    retractLockGuide: "Retirar Candado",
    shareModeHeader: "Modo de Compartir",
    normalGrantAccess: "Acceso Normal",
    recurringGrantAccess: "Acceso Recurrente",
    recurringTimedGrantAccess: "Acceso Recurrente Programado",
    multiApproveAccess: "Acceso de Aprobación Múltiple",
    multiApproveOneTimeAccess: "Aprobación Múltiple y Acceso Único",
    oneTimeAccess: "Acceso Único",
    individualTab: "Candado Individual",
    groupTab: " Grupo de Candados",
    searchPlaceholder: "Buscar",
    groupNameHeader: "Nombre del Grupo de Candados",
    groupNumberHeader: "Número de Candados del Grupo",
    viewHeader: "Ver Candados",
  },
});

const buildRetractAccessMessage = (rowKeys = [], rows = [], type = "lock") => {
  const selectedKeys = new Set(rowKeys);
  const lines = [];
  let count = 0;

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];

    if (selectedKeys.has(row.key)) {
      const name = row.name || "-";
      const shareTo = row.shareto || "-";
      const serial = row.lockSerial || "-";
      const shareMode = row.shareMode ? row.shareMode : "-";

      if (type === "group") {
        lines.push(`${count + 1}. ${name} — ${shareTo}`);
      } else {
        lines.push(`${count + 1}. ${name} <${serial}> — ${shareTo}`);
      }

      count += 1;
      if (count === 5) break;
    }
  }

  const total = rowKeys.length;

  return (
    <div>
      <div>
        You are about to retract <strong>{total}</strong> selected access
        {total > 1 ? "es" : ""}.
      </div>

      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}

        {total > 5 && (
          <div style={{ marginTop: "8px", fontStyle: "italic" }}>
            ...and {total - 5} more.
          </div>
        )}
      </div>

      <div>Retract all selected access to users?</div>
    </div>
  );
};

const customConfirmDialog = (next, rowKeys, rows = [], type = "lock") => {
  confirmAlert({
    title: `Confirm retract access (${rowKeys.length})`,
    message: buildRetractAccessMessage(rowKeys, rows, type),
    buttons: [
      {
        label: "Confirm",
        onClick: () => next(),
      },
      {
        label: "Cancel",
        onClick: () => false,
      },
    ],
  });
};

const isValidRetractableRecord = (record, key) => {
  if (!record || typeof record !== "object") return false;

  return (
    record.id &&
    record.id === key &&
    typeof record.allowAccess === "boolean" &&
    record.sharedLockName &&
    record.sharedToEmail &&
    record.lockSerial &&
    record.sharedToUID
  );
};
class RetractableAccess extends Component {
  constructor(props) {
    super(props);
    this.renderDropdown = this.renderDropdown.bind(this);
    // Force Update
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.onAfterDeleteGroupRow = this.onAfterDeleteGroupRow.bind(this);
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
    this.detectOnChangeEvent = this.detectOnChangeEvent.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);
    this.fetchSelectedUserData = this.fetchSelectedUserData.bind(this);
    this.reverseSnapshot = this.reverseSnapshot.bind(this);
    this.renderBtn = this.renderBtn.bind(this);
    this.checkStartDate = this.checkStartDate.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.checkEndDate = this.checkEndDate.bind(this);
    this.renderSizePerPageDropDown = this.renderSizePerPageDropDown.bind(this);
    this.onToggleDropDown = this.onToggleDropDown.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.isASharedMode = this.isASharedMode.bind(this);
    this.handleTabs = this.handleTabs.bind(this);
    this.renderMultiApprovalInfo = this.renderMultiApprovalInfo.bind(this);

    this.state = {
      accessArray: [],
      lockIndividuals: [],
      accessArrayGroup: [],
      lockgrouplock: [],
      lockNameArray: [],
      loading: true,
      show: false,
      _notificationSystem: null,
      showPopup: false,
      popupTitle: "",
      popupImage: [],
      imageSrc: individuallock,
      selectedTabIndex: 0,
      selectedIndividualAccesses: [],
      selectedGroupAccesses: [],
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    // fire
    //   .database()
    //   .ref("retractableSharingRegistry")
    //   .child(auth.currentUser.uid)
    //   .orderByChild("sharedOn")
    //   .once("value")
    //   .then((snapshot) => {
    //     // console.log(snapshot.val());
    //     //console.log(this.reverseSnapshot(snapshot));

    //     // const snapshotVal = this.reverseSnapshot(snapshot);
    //     const snapshotVal = snapshot.val();
    //     let lockArrayForIndividuals = [];
    //     let lockgrouplock = [];
    //     let lockArrayForGroups = [];
    //     let lockIndividuals = [];
    //     for (const eachLockId in snapshotVal) {
    //       if (snapshotVal[eachLockId].lockSerial != "group") {
    //         lockIndividuals.push(snapshotVal[eachLockId]);
    //       } else if (snapshotVal[eachLockId].lockSerial == "group") {
    //         fire
    //           .database()
    //           .ref("lockGroupManagement")
    //           .child(auth.currentUser.uid)
    //           .once("value")
    //           .then(async (snapshot) => {
    //             let count = 0;
    //             snapshot.forEach(async (childSnapshot) => {
    //               const lockData2 = childSnapshot.val();
    //               Object.values(lockData2).forEach((lock) => {
    //                 const lockName = lock.name;
    //                 if (lockName === snapshotVal[eachLockId].sharedLockName) {
    //                   count += Object.keys(lock.locks).length;
    //                 }
    //               });
    //             });
    //             // console.log("Total count:", count);

    //             lockgrouplock.push({
    //               lockDetails: snapshotVal[eachLockId],
    //               count: count,
    //             });
    //             this.setState({ lockgrouplock: lockgrouplock.reverse() });
    //           });
    //       } else if (
    //         snapshotVal[eachLockId].sharingMode === "" ||
    //         snapshotVal[eachLockId].sharingMode === "NORMAL" ||
    //         snapshotVal[eachLockId].sharingMode === "OTA" ||
    //         snapshotVal[eachLockId].sharingMode === "MULTI" ||
    //         snapshotVal[eachLockId].sharingMode === "MULTI-OTA" ||
    //         snapshotVal[eachLockId].sharingMode === undefined || // grant access by mobile applications
    //         // for recurring access
    //         snapshotVal[eachLockId].sharingMode === "NORMAL-RECURR" ||
    //         snapshotVal[eachLockId].sharingMode === "NORMAL-RECURR-TIMED"
    //       ) {
    //         lockArrayForIndividuals.push(snapshotVal[eachLockId]);
    //       } else if (
    //         snapshotVal[eachLockId].sharingMode === "NORMAL-GRP" ||
    //         snapshotVal[eachLockId].sharingMode === "OTA-GRP" ||
    //         snapshotVal[eachLockId].sharingMode === "MULTI-GRP" ||
    //         snapshotVal[eachLockId].sharingMode === "MULTI-OTA-GRP" ||
    //         // for recurring access
    //         snapshotVal[eachLockId].sharingMode === "NORMAL-RECURR-GRP" ||
    //         snapshotVal[eachLockId].sharingMode === "NORMAL-RECURR-TIMED-GRP"
    //       ) {
    //         lockArrayForGroups.push(snapshotVal[eachLockId]);
    //       }
    //     }

    //     this.setState({
    //       // accessArray: this.reverseSnapshot(snapshot),
    //       accessArray: lockArrayForIndividuals.reverse(),
    //       lockgrouplock: lockgrouplock.reverse(),
    //       accessArrayGroup: lockArrayForGroups.reverse(),
    //       lockIndividuals: lockIndividuals.reverse(),
    //       loading: false,
    //     });
    //     // console.log(this.state.lockgrouplock);

    //     // console.log("lockgrouplock Lock Data:", lockgrouplock);
    //     // console.log("accessArrayGroup Lock Data:", accessArrayGroup);
    //   })
    //   .catch((err) => customLog(err));

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        //snapshot takes the value of the .ref
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            //sends the snapshot data into superadmin using a foreach
            const superAdminData = superAdmin.val(); //.val required to pull value
            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                const maxUserLocks = superAdminData.payment.maxLocks;

                fire
                  .database()
                  .ref("MyAdminLocks/" + superAdminID)
                  .once("value")
                  .then((snapshot) => {
                    const childInDb = snapshot.numChildren();
                    if (childInDb > maxUserLocks) {
                      this.showNotification(
                        localizationStrings.exceededLockLimits,
                        "error",
                        "tc",
                        0,
                      );
                    }
                  });

                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });

    Promise.all([
      // 🔹 Fetch individual shares
      fire
        .database()
        .ref("retractableSharingRegistry")
        .child(auth.currentUser.uid)
        .orderByChild("sharedOn")
        .once("value"),

      // 🔹 Fetch group locks
      fire
        .database()
        .ref("lockGroupManagement")
        .child(auth.currentUser.uid)
        .once("value"),
    ])
      .then(([indivSnap, groupSnap]) => {
        // -----------------------------
        // 1. Process individuals
        // -----------------------------
        const snapshotVal = indivSnap.val() || {};
        let lockArrayForIndividuals = [];
        let lockArrayForGroups = [];
        let lockIndividuals = [];

        for (const eachLockId in snapshotVal) {
          const lockData = snapshotVal[eachLockId];

          if (!isValidRetractableRecord(lockData, eachLockId)) {
            console.warn("Skipped invalid retractableSharingRegistry record:", {
              key: eachLockId,
              data: lockData,
            });
            continue;
          }

          if (lockData.lockSerial !== "group") {
            lockIndividuals.push(lockData);
          }

          if (
            lockData.sharingMode === "" ||
            lockData.sharingMode === "NORMAL" ||
            lockData.sharingMode === "OTA" ||
            lockData.sharingMode === "MULTI" ||
            lockData.sharingMode === "MULTI-OTA" ||
            lockData.sharingMode === "NORMAL-RECURR" ||
            lockData.sharingMode === "NORMAL-RECURR-TIMED"
          ) {
            lockArrayForIndividuals.push(lockData);
            customLog("Individual Lock Data:", lockArrayForIndividuals);
            // console.log("Individual Lock Data:", lockArrayForIndividuals);
          } else if (
            lockData.sharingMode === "NORMAL-GRP" ||
            lockData.sharingMode === "OTA-GRP" ||
            lockData.sharingMode === "MULTI-GRP" ||
            lockData.sharingMode === "MULTI-OTA-GRP" ||
            lockData.sharingMode === "NORMAL-RECURR-GRP" ||
            lockData.sharingMode === "NORMAL-RECURR-TIMED-GRP"
          ) {
            lockArrayForGroups.push(lockData);
          }
        }

        // -----------------------------
        // 2. Process group locks
        // -----------------------------
        let lockgrouplock = [];

        groupSnap.forEach((creatorSnap) => {
          // adminWhoCreateId
          creatorSnap.forEach((groupSnap) => {
            // groupHash
            const groupHash = groupSnap.key; // e.g. -0VApcKnsYndkJang5s
            const groupData = groupSnap.val();
            const sharedInstances = groupData.sharedInstances || {};
            const count = Object.keys(groupData.locks || {}).length;

            Object.entries(sharedInstances).forEach(
              ([instanceId, instanceData]) => {
                lockgrouplock.push({
                  count, // number of locks in this group
                  lockDetails: {
                    allowAccess: instanceData.allowAccess || false,
                    hasAccessed: instanceData.hasAccessed || false,
                    id: instanceId, // sharedInstance id
                    isOfflineLock: instanceData.isOfflineLock || false,
                    lockId: groupHash, // 🔑 use groupHash as lockId
                    lockSerial: "group", // 🔑 fixed
                    senderUID: auth.currentUser.uid || "",
                    shareAccessToken:
                      instanceData.shareAccessToken || instanceId,
                    shareEndTime: instanceData.shareEndTime || 0,
                    sharePermissionType: instanceData.sharePermissionType || 0,
                    shareStartTime: instanceData.shareStartTime || 0,
                    // Combine group lock name + recipient name
                    sharedLockName: groupData.name,
                    sharedOn: groupData.createdOn || 0, // 🔑 use group createdOn
                    sharedToEmail: instanceData.recipientName || "",
                    sharedToUID: instanceData.recipientUID || "",
                    sharingMode: instanceData.sharingMode || "NORMAL-GRP",
                    desc: groupData.desc || "", // 🔑 include group description
                  },
                });
              },
            );
          });
        });

        // -----------------------------
        // 3. Update state once
        // -----------------------------
        this.setState({
          accessArray: lockArrayForIndividuals.reverse(),
          lockgrouplock: lockgrouplock.reverse(),
          accessArrayGroup: lockArrayForGroups.reverse(),
          lockIndividuals: lockIndividuals.reverse(),
          loading: false,
        });

        // console.log("Group Lock Data:", lockgrouplock);
      })
      .catch((err) => customLog(err));

    // axios
    //   .get(
    //     process.env.REACT_APP_FIREBASE_DATABASE +
    //     "/" +
    //     doGetLocklist() +
    //     ".json?auth=" +
    //     process.env.REACT_APP_FIREBASE_DATABASE_SECRET
    //   )
    //   .then((response) => {
    //     this.setState({ lockNameArray: response.data, loading: false });
    //   })
    //   .catch((err) => {
    //     customLog(err);
    //   });

    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  showNotification(msg, lvl) {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: 3,
    });
  }

  async onAfterDeleteRow(rowKeys) {
    try {
      for (let i = 0; i < rowKeys.length; i++) {
        const result = await new Promise((resolve) => {
          deleteRetractableId(rowKeys[i], (success) => {
            resolve(success);
          });
        });

        if (result) {
          customLog("ok");
          this.showNotification("Lock access has been retracted!", "success");
        } else {
          customLog("fail");
          this.showNotification(
            "Unable to retract access, Please try again",
            "error",
          );
        }
      }
    } catch (error) {
      customLog("Error during deletion:", error);
      this.showNotification("An error occurred. Please try again", "error");
    }
  }

  async onAfterDeleteGroupRow(rowKeys) {
    try {
      for (let i = 0; i < rowKeys.length; i++) {
        const row = this.state.lockgrouplock.find(
          (d) => d.lockDetails.id === rowKeys[i],
        );

        if (!row) continue;

        const payload = {
          id: row.lockDetails.id,
          lockId: row.lockDetails.lockId, // make sure this exists in row.lockDetails
          lockSerial: row.lockDetails.lockSerial,
          sharedLockName: row.lockDetails.sharedLockName,
          sharedToEmail: row.lockDetails.sharedToEmail, // rename to match function usage
          sharedToUID: row.lockDetails.sharedToUID, // if group sharing
          senderUID: row.lockDetails.senderUID, // who shared the lock
          shareMode: row.lockDetails.sharingMode,
          start: row.lockDetails.shareStartTime,
          end: row.lockDetails.shareEndTime,
        };

        const result = await new Promise((resolve) => {
          deleteRetractableGroupId(payload, (success) => {
            resolve(success);
          });
        });

        if (result) {
          customLog("✅ ok", payload);
          this.showNotification(
            `${payload.sharedLockName} access has been retracted!`,
            "success",
          );
          //await this.fetchGroupLocks();
        } else {
          customLog("❌ fail", payload);
          this.showNotification(
            `Unable to retract ${payload.sharedLockName}, please try again`,
            "error",
          );
        }
      }
    } catch (error) {
      customLog("Error during deletion:", error);
      this.showNotification("An error occurred. Please try again", "error");
    }
  }

  // 🔹 Create a helper function to fetch group locks
  fetchGroupLocks = async () => {
    try {
      const groupSnap = await fire
        .database()
        .ref("lockGroupManagement")
        .child(auth.currentUser.uid)
        .once("value");

      let lockgrouplock = [];

      groupSnap.forEach((creatorSnap) => {
        creatorSnap.forEach((groupSnap) => {
          const groupHash = groupSnap.key;
          const groupData = groupSnap.val();
          const sharedInstances = groupData.sharedInstances || {};
          const count = Object.keys(groupData.locks || {}).length;

          Object.entries(sharedInstances).forEach(
            ([instanceId, instanceData]) => {
              lockgrouplock.push({
                count,
                lockDetails: {
                  allowAccess: instanceData.allowAccess || false,
                  hasAccessed: instanceData.hasAccessed || false,
                  id: instanceId,
                  isOfflineLock: instanceData.isOfflineLock || false,
                  lockId: groupHash,
                  lockSerial: "group",
                  senderUID: auth.currentUser.uid || "",
                  shareAccessToken: instanceData.shareAccessToken || instanceId,
                  shareEndTime: instanceData.shareEndTime || 0,
                  sharePermissionType: instanceData.sharePermissionType || 0,
                  shareStartTime: instanceData.shareStartTime || 0,
                  sharedLockName: groupData.name,
                  sharedOn: groupData.createdOn || 0,
                  sharedToEmail: instanceData.recipientName || "",
                  sharedToUID: instanceData.recipientUID || "",
                  sharingMode: instanceData.sharingMode || "NORMAL-GRP",
                  desc: groupData.desc || "",
                },
              });
            },
          );
        });
      });

      // 🔹 Update only group locks in state
      this.setState({
        lockgrouplock: lockgrouplock.reverse(),
      });

      // console.log("✅ Refetched Group Lock Data:", lockgrouplock);
    } catch (error) {
      customLog("❌ Error fetching group locks:", error);
    }
  };

  reverseSnapshot(snapshot) {
    const jsonArray = [];
    let convertedJsonObject = {};

    snapshot.forEach((currVal) => {
      jsonArray.push(currVal.val());
    });

    const reversedArr = jsonArray.reverse();
    reversedArr.forEach((currVal) => {
      convertedJsonObject[currVal.id] = currVal;
    });

    return convertedJsonObject;
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="searchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  };

  createCustomDeleteButton = (onClick) => {
    return (
      <Button
        bsSize="large"
        id="retractableBtn"
        style={{ width: "100%" }}
        onClick={onClick}
      >
        <i className="far fa-trash-alt" />{" "}
        {localizationStrings.removeSelectedBtn}
      </Button>
    );
  };

  // Handler for Force Update
  forceUpdateHandler() {
    this.forceUpdate();
  }

  checkStartDate(shareStartTime) {
    if (shareStartTime === 0 || shareStartTime === "") {
      return "∞";
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(shareStartTime * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(shareStartTime * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={shareStartTime} format="full" includeDay />;
        return <TimeStamp time={shareStartTime} format="full" />;
      }
    }
  }
  checkEndDate(shareEndTime) {
    if (shareEndTime === 0 || shareEndTime === "") {
      return "∞";
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(shareEndTime * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(shareEndTime * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={shareEndTime} format="full" includeDay />;
        return <TimeStamp time={shareEndTime} format="full" />;
      }
    }
  }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  renderDropdown() {
    return _.map(this.state.lockNameArray, (accessData) => {
      return <option value={accessData.id}>{accessData.Name}</option>;
    });
  }

  detectOnChangeEvent(event) {
    if (event.target.value === "showAll") {
      this.fetchAllSelectedUserData();
    }
    this.fetchSelectedUserData(event.target.value);
  }

  fetchSelectedUserData(a) {
    fire
      .database()
      .ref("retractableSharingRegistry")
      .child(auth.currentUser.uid)
      .orderByChild("lockId")
      .equalTo(a)
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot).reverse();
        this.setState({
          accessArray: tempArray,
        });
      });
  }

  fetchAllSelectedUserData() {
    fire
      .database()
      .ref("retractableSharingRegistry")
      .child(auth.currentUser.uid)
      .orderByChild("lockId")
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot).reverse();
        this.setState({
          accessArray: tempArray,
        });
      });
  }

  snapshotToArray = (snapshot) => {
    const returnArr = [];

    snapshot.forEach((childSnapshot) => {
      const item = childSnapshot.val();
      const key = childSnapshot.key;

      if (!isValidRetractableRecord(item, key)) {
        console.warn("Skipped invalid retractable record in snapshotToArray:", {
          key,
          data: item,
        });
        return;
      }

      item.key = key;
      returnArr.push(item);
    });

    return returnArr;
  };

  renderBtn(accessData) {
    if (!accessData || !accessData.id) {
      console.warn("SwitchBtn not rendered. Invalid accessData:", accessData);
      return null;
    }

    return <SwitchBtn accessData={accessData} />;
  }

  renderGroupBtn(accessData) {
    // customLog(accessData);
    return <GroupSwitchBtn accessData={accessData} />;
  }

  viewLocksBtn(cell, row) {
    return <Infolockbutton cellValue={cell} rowValue={row} />;
    // return <SwitchBtn accessData={accessData} />;
  }

  onToggleDropDown = (toggleDropDown) => {
    // do your stuff here
    // console.log(toggleDropDown)
    // console.log("toggle dropdown");
    toggleDropDown();
  };

  renderSizePerPageDropDown = (props) => {
    return (
      <SizePerPageDropDown
        // className='my-size-per-page'
        // btnContextual='btn-warning'
        variation="dropup"
        onClick={() => this.onToggleDropDown(props.toggleDropDown)}
        {...props}
      />
    );
  };

  renderMultiApprovalInfo(cell, row) {
    if (!row || !row.key || !cell || !cell.id) {
      console.warn("MultiApprovalInfo not rendered. Invalid row/cell:", {
        row,
        cell,
      });
      return null;
    }

    return <MultiApprovalInfo cellValue={cell} rowValue={row} />;
  }

  handlePopupOpen() {
    this.setState({
      showPopup: true,
      popupTitle: localizationStrings.retractLockGuide,
      popupImage: [<RetractLock />],
    });
  }

  handlePopupClose() {
    this.setState({ showPopup: false });
  }

  isASharedMode(shareMode) {
    if (
      shareMode === "" ||
      shareMode === "NORMAL" ||
      shareMode === "NORMAL-GRP" ||
      shareMode == null
    ) {
      return localizationStrings.normalGrantAccess;
    } else if (shareMode === "MULTI" || shareMode === "MULTI-GRP") {
      return localizationStrings.multiApproveAccess;
    } else if (shareMode === "MULTI-OTA" || shareMode === "MULTI-OTA-GRP") {
      return localizationStrings.multiApproveOneTimeAccess;
    } else if (shareMode === "OTA" || shareMode === "OTA-GRP") {
      return localizationStrings.oneTimeAccess;
    } else if (
      shareMode === "NORMAL-RECURR" ||
      shareMode === "NORMAL-RECURR-GRP"
    ) {
      return localizationStrings.recurringGrantAccess;
    } else if (
      shareMode === "NORMAL-RECURR-TIMED" ||
      shareMode === "NORMAL-RECURR-TIMED-GRP"
    ) {
      return localizationStrings.recurringTimedGrantAccess;
    }

    //else check if RECURR
  }

  handleTabs() {
    fire
      .database()
      .ref("retractableSharingRegistry")
      .child(auth.currentUser.uid)
      .orderByChild("sharedOn")
      .once("value")
      .then((snapshot) => {
        // console.log(snapshot.val());
        //console.log(this.reverseSnapshot(snapshot));

        // const snapshotVal = this.reverseSnapshot(snapshot);
        const snapshotVal = snapshot.val();

        let lockArrayForIndividuals = [];
        let lockArrayForGroups = [];
        let lockgrouplock = [];
        let lockIndividuals = [];
        for (const eachLockId in snapshotVal) {
          const lockData = snapshotVal[eachLockId];

          if (!isValidRetractableRecord(lockData, eachLockId)) {
            console.warn(
              "Skipped invalid retractableSharingRegistry record in handleTabs:",
              {
                key: eachLockId,
                data: lockData,
              },
            );
            continue;
          }

          if (lockData.lockSerial != "group") {
            lockIndividuals.push(snapshotVal[eachLockId]);
          } else if (snapshotVal[eachLockId].lockSerial == "group") {
            //add

            fire
              .database()
              .ref("lockGroupManagement")
              .child(auth.currentUser.uid)
              .once("value")
              .then(async (snapshot) => {
                let count = 0;
                snapshot.forEach(async (childSnapshot) => {
                  const lockData2 = childSnapshot.val();
                  Object.values(lockData2).forEach((lock) => {
                    const lockName = lock.name;
                    if (lockName === snapshotVal[eachLockId].sharedLockName) {
                      count += Object.keys(lock.locks).length;
                    }
                  });
                });
                // console.log("Total count:", count);

                lockgrouplock.push({
                  lockDetails: snapshotVal[eachLockId],
                  count: count,
                });
                this.setState({ lockgrouplock: lockgrouplock.reverse() });
              });
          } else if (
            snapshotVal[eachLockId].sharingMode === "" ||
            snapshotVal[eachLockId].sharingMode === "NORMAL" ||
            snapshotVal[eachLockId].sharingMode === "OTA" ||
            snapshotVal[eachLockId].sharingMode === "MULTI" ||
            snapshotVal[eachLockId].sharingMode === "MULTI-OTA" ||
            // snapshotVal[eachLockId].sharingMode === undefined || // grant access by mobile applications
            // for recurring access
            snapshotVal[eachLockId].sharingMode === "NORMAL-RECURR" ||
            snapshotVal[eachLockId].sharingMode === "NORMAL-RECURR-TIMED"
          ) {
            lockArrayForIndividuals.push(snapshotVal[eachLockId]);
          } else if (
            snapshotVal[eachLockId].sharingMode === "NORMAL-GRP" ||
            snapshotVal[eachLockId].sharingMode === "OTA-GRP" ||
            snapshotVal[eachLockId].sharingMode === "MULTI-GRP" ||
            snapshotVal[eachLockId].sharingMode === "MULTI-OTA-GRP" ||
            // for recurring access
            snapshotVal[eachLockId].sharingMode === "NORMAL-RECURR-GRP" ||
            snapshotVal[eachLockId].sharingMode === "NORMAL-RECURR-TIMED-GRP"
          ) {
            lockArrayForGroups.push(snapshotVal[eachLockId]);
          }
        }
        // console.log(lockgrouplock);
        this.setState({
          // accessArray: this.reverseSnapshot(snapshot),
          accessArray: lockArrayForIndividuals.reverse(),
          lockgrouplock: lockgrouplock.reverse(),
          accessArrayGroup: lockArrayForGroups.reverse(),
          lockIndividuals: lockIndividuals.reverse(),
          loading: false,
        });
      })
      .catch((err) => customLog(err));
  }
  handleTabClick = (index) => {
    this.setState({ selectedTabIndex: index });
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const selectRowPropIndividual = {
      bgColor: "#eeeeee",
      mode: "checkbox",
      // clickToSelect: true,
      selected: this.state.selectedIndividualAccesses,
      onSelect: (row, isSelected) => {
        const { selectedIndividualAccesses } = this.state;

        const updatedSelectedRows = isSelected
          ? [...selectedIndividualAccesses, row.key]
          : selectedIndividualAccesses.filter((key) => key !== row.key);

        this.setState({ selectedIndividualAccesses: updatedSelectedRows });
      },
      onSelectAll: (isSelected) => {
        const updatedSelectedRows = isSelected
          ? iData.map((row) => row.key)
          : [];

        this.setState({ selectedIndividualAccesses: updatedSelectedRows });
      },
    };

    const selectRowPropGroup = {
      bgColor: "#eeeeee",
      mode: "checkbox",
      // clickToSelect: true,
      selected: this.state.selectedGroupAccesses,
      onSelect: (row, isSelected) => {
        const { selectedGroupAccesses } = this.state;

        const updatedSelectedRows = isSelected
          ? [...selectedGroupAccesses, row.key]
          : selectedGroupAccesses.filter((key) => key !== row.key);

        this.setState({ selectedGroupAccesses: updatedSelectedRows });
      },
      onSelectAll: (isSelected) => {
        const updatedSelectedRows = isSelected
          ? grData.map((row) => row.key)
          : [];

        this.setState({ selectedGroupAccesses: updatedSelectedRows });
      },
    };

    const rData = _.map(this.state.accessArray, (accessData) => {
      // console.log(accessData);
      // customLog(accessData);
      return {
        key: accessData.id,
        name: accessData.sharedLockName,
        lockSerial: accessData.lockSerial,
        shareto: accessData.sharedToEmail,
        start: accessData.shareStartTime,
        end: accessData.shareEndTime,
        shareMode: accessData.sharingMode,
        access: accessData,
      };
    });

    const gData = _.map(this.state.accessArrayGroup, (accessData) => {
      // customLog(accessData);
      return {
        key: accessData.id,
        name: accessData.sharedLockName,
        lockSerial: accessData.lockSerial,
        shareto: accessData.sharedToEmail,
        start: accessData.shareStartTime,
        end: accessData.shareEndTime,
        shareMode: accessData.sharingMode,
        access: accessData,
      };
    });
    const grData = _.map(
      this.state.lockgrouplock.sort(
        (a, b) => b.lockDetails.sharedOn - a.lockDetails.sharedOn,
      ),
      (accessData) => {
        // console.log(this.state.lockgrouplock);
        // customLog(accessData);
        return {
          key: accessData.lockDetails.id,
          name: accessData.lockDetails.sharedLockName,
          lockSerial: accessData.lockDetails.lockSerial,
          shareto: accessData.lockDetails.sharedToEmail,
          start: accessData.lockDetails.shareStartTime,
          end: accessData.lockDetails.shareEndTime,
          shareMode: accessData.lockDetails.sharingMode,
          access: accessData.lockDetails,
          count: accessData.count,
        };
      },
    );
    const iData = _.map(
      (this.state.lockIndividuals || []).filter((accessData) =>
        isValidRetractableRecord(accessData, accessData && accessData.id),
      ),
      (accessData) => {
        return {
          key: accessData.id,
          name: accessData.sharedLockName,
          lockSerial: accessData.lockSerial,
          shareto: accessData.sharedToEmail,
          start: accessData.shareStartTime,
          end: accessData.shareEndTime,
          shareMode: accessData.sharingMode,
          access: accessData,
        };
      },
    );

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      afterDeleteRow: this.onAfterDeleteRow,
      handleConfirmDeleteRow: (next, rowKeys) =>
        customConfirmDialog(next, rowKeys, iData, "lock"),
      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: iData.length,
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 10, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      paginationShowsTotal: customTotal,
      noDataText: this.loadingData(), // Accept bool or function
      deleteBtn: this.createCustomDeleteButton,
      // default is bottom, top and both is all available
      // hideSizePerPage: true > You can hide the dropdown for sizePerPage
      // alwaysShowAllBtns: true // Always show next and previous button
      // withFirstAndLast: false > Hide the going to First and Last page button// A hook for after droping rows.
      searchField: this.createCustomSearchField,
    };

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };
    const { selectedTabIndex } = this.state;

    return (
      <div
        style={{
          maxWidth: "95%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="search">
          <div className="header">
            <h4>{localizationStrings.retractDescription}</h4>
            <h4>{localizationStrings.retractDescription2}</h4>
          </div>
        </div>
        {/* <br /> */}
        {/* <Tabs defaultIndex={0} onSelect={this.handleTabs}> */}
        <Tabs defaultIndex={0}>
          <TabList>
            <Tab onClick={() => this.handleTabClick(0)}>
              <img
                src={
                  selectedTabIndex === 0
                    ? individuallocknopress
                    : individuallock
                }
                alt="Tab 1"
                style={{ width: "30px", height: "30px" }}
              />
              {localizationStrings.individualTab}
            </Tab>
            {this.state.isSuperAdmin && (
              <Tab onClick={() => this.handleTabClick(1)}>
                <img
                  src={
                    selectedTabIndex === 1 ? grouplockpiconpress : grouplockpic
                  }
                  alt="Tab 2"
                  style={{ width: "30px", height: "30px" }}
                />
                {localizationStrings.groupTab}
              </Tab>
            )}

            {/* <Tab>{localizationStrings.lockSchedulingTab}</Tab>
            <Tab>{localizationStrings.groupSharingTab}</Tab> */}
          </TabList>
          {/* //! RETRACT ACCESS FOR INDIVIDUALS */}
          <TabPanel>
            <br />
            <br />

            <div
              style={{
                // maxWidth: "95%",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <BootstrapTable
                pagination={true}
                search
                bordered={false}
                data={iData}
                selectRow={selectRowPropIndividual}
                deleteRow
                options={options}
                className="horizontalScrollFade stickyColumn"
              >
                <TableHeaderColumn dataField="key" isKey={true} hidden>
                  Key
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="name"
                  dataSort
                  columnTitle={columnHover}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ width: "150px" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="lockSerial"
                  dataSort
                  columnTitle={columnHover}
                  thStyle={{ width: "130px" }}
                  tdStyle={{ width: "130px" }}
                >
                  {localizationStrings.lockSerialHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="shareto"
                  dataSort
                  columnTitle={columnHover}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ width: "150px" }}
                >
                  {localizationStrings.shareToHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="shareMode"
                  dataFormat={this.isASharedMode}
                  dataSort
                  columnTitle={this.isASharedMode}
                  thStyle={{ width: "150px" }}
                  tdStyle={{
                    whiteSpace: "normal",
                    width: "150px",
                    wordWrap: "break-word",
                  }}
                >
                  {localizationStrings.shareModeHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="start"
                  dataFormat={this.checkStartDate}
                  // columnTitle={this.checkStartDate}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ whiteSpace: "normal", width: "150px" }}
                >
                  {localizationStrings.startHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="end"
                  dataFormat={this.checkEndDate}
                  // columnTitle={this.checkEndDate}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ whiteSpace: "normal", width: "150px" }}
                >
                  {localizationStrings.endHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  // dataField="groupName"
                  dataFormat={this.renderMultiApprovalInfo}
                  // dataSort
                  tdStyle={{ textAlign: "center", width: "80px" }}
                  thStyle={{ textAlign: "center", width: "80px" }}
                >
                  {localizationStrings.infoHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="access"
                  dataFormat={this.renderBtn}
                  thStyle={{ textAlign: "center", width: "150px" }}
                  tdStyle={{ textAlign: "center", width: "150px" }}
                >
                  {localizationStrings.allowAccessHeader}
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </TabPanel>
          {/* //! RETRACT ACCESS FOR GROUPS */}
          <TabPanel>
            <br />
            <br />

            <div
              style={{
                // maxWidth: "95%",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <BootstrapTable
                pagination={true}
                search
                bordered={false}
                data={grData}
                selectRow={selectRowPropGroup}
                deleteRow
                className="horizontalScrollFade stickyColumn"
                // options={options}
                options={{
                  afterDeleteRow: this.onAfterDeleteGroupRow,
                  handleConfirmDeleteRow: (next, rowKeys) =>
                    customConfirmDialog(next, rowKeys, grData, "group"),
                  page: 1, // which page you want to show as default
                  sizePerPageList: [
                    {
                      text: "10",
                      value: 10,
                    },
                    {
                      text: "100",
                      value: 100,
                    },
                    {
                      text: "All",
                      value: grData.length,
                    },
                  ], // you can change the dropdown list for size per page
                  sizePerPage: 10, // which size per page you want to locate as default
                  pageStartIndex: 1, // where to start counting the pages
                  paginationSize: 3, // the pagination bar size.
                  prePage: "<", // Previous page button text
                  nextPage: ">", // Next page button text
                  firstPage: "<<", // First page button text
                  lastPage: ">>", // Last page button text
                  paginationShowsTotal: customTotal,
                  noDataText: this.loadingData(), // Accept bool or function
                  deleteBtn: this.createCustomDeleteButton,
                  // default is bottom, top and both is all available
                  // hideSizePerPage: true > You can hide the dropdown for sizePerPage
                  // alwaysShowAllBtns: true // Always show next and previous button
                  // withFirstAndLast: false > Hide the going to First and Last page button// A hook for after droping rows.
                  searchField: this.createCustomSearchField,
                }}
              >
                <TableHeaderColumn dataField="key" isKey={true} hidden>
                  Key
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="name"
                  dataSort
                  columnTitle={columnHover}
                  thStyle={{ width: "200px" }}
                  tdStyle={{ width: "200px" }}
                >
                  {/* {localizationStrings.nameHeader} */}
                  {localizationStrings.groupNameHeader}
                  {/* done */}
                </TableHeaderColumn>
                {/* <TableHeaderColumn
                  dataField="count"
                  dataSort
                  columnTitle={columnHover}
                  thStyle={{ width: "160px" }}
                  tdStyle={{ width: "160px" }}
                >
                  {/* {localizationStrings.lockSerialHeader} 
                  {localizationStrings.groupNumberHeader}
                </TableHeaderColumn> */}
                <TableHeaderColumn
                  dataField="shareto"
                  dataSort
                  columnTitle={columnHover}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ width: "150px" }}
                >
                  {/* {localizationStrings.shareToHeader} */}
                  {localizationStrings.shareToHeader}
                  {/* done */}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="shareMode"
                  dataFormat={this.isASharedMode}
                  dataSort
                  columnTitle={this.isASharedMode}
                  thStyle={{ width: "180px" }}
                  tdStyle={{
                    whiteSpace: "normal",
                    width: "180px",
                    wordWrap: "break-word",
                  }}
                >
                  {/* {localizationStrings.shareModeHeader} */}
                  {localizationStrings.shareModeHeader}
                  {/* done */}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="start"
                  dataFormat={this.checkStartDate}
                  // columnTitle={this.checkStartDate}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ whiteSpace: "normal", width: "150px" }}
                >
                  {/* {localizationStrings.startHeader} */}
                  {localizationStrings.startHeader}
                  {/* done */}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="end"
                  dataFormat={this.checkEndDate}
                  // columnTitle={this.checkEndDate}
                  thStyle={{ width: "150px" }}
                  tdStyle={{ whiteSpace: "normal", width: "150px" }}
                >
                  {/* {localizationStrings.endHeader} */}
                  {localizationStrings.endHeader}
                  {/* done */}
                </TableHeaderColumn>
                <TableHeaderColumn
                  // dataField="groupName"
                  dataFormat={this.renderMultiApprovalInfo}
                  // dataSort
                  tdStyle={{ textAlign: "center", width: "80px" }}
                  thStyle={{ textAlign: "center", width: "80px" }}
                >
                  {/* {localizationStrings.infoHeader} */}
                  {localizationStrings.infoHeader}
                  {/* done */}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="access"
                  dataFormat={this.renderGroupBtn}
                  thStyle={{ textAlign: "center", width: "150px" }}
                  tdStyle={{ textAlign: "center", width: "150px" }}
                >
                  {/* {localizationStrings.allowAccessHeader} */}
                  {localizationStrings.allowAccessHeader}
                  {/* done */}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="access"
                  dataFormat={this.viewLocksBtn}
                  thStyle={{ textAlign: "center", width: "200px" }}
                  tdStyle={{ textAlign: "center", width: "200px" }}
                >
                  {/* {localizationStrings.allowAccessHeader} */}
                  {localizationStrings.viewHeader}
                </TableHeaderColumn>
                {/* <TableHeaderColumn
                  dataField="access"
                  dataFormat={this.renderBtn}
                  thStyle={{ textAlign: "center", width: "150px" }}
                  tdStyle={{ textAlign: "center", width: "150px" }}
                > */}
                {/* {localizationStrings.allowAccessHeader} */}
                {/* Edit
                </TableHeaderColumn> */}
              </BootstrapTable>
            </div>
          </TabPanel>
        </Tabs>
        <br />
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.popupTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.state.popupImage}</Modal.Body>
        </Modal>
        <div className="empty-space"></div>
        {/* <Chatbot/> */}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(RetractableAccess);
